import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getArticlePreview } from "./articleFormatter";
import { topicPlaceHolder } from "./random";
export var getTopic = function getTopic(isLoading, sections, topicId) {
  var _currentTopic$article;
  if (isLoading) {
    return topicPlaceHolder;
  }
  var currentTopic = sections.find(function (section) {
    return section.id === topicId;
  });
  if (!currentTopic) {
    return topicPlaceHolder;
  }
  var topic = _objectSpread(_objectSpread({}, currentTopic), {}, {
    articles: (_currentTopic$article = currentTopic.articles.filter(function (article) {
      return !article.draft;
    })) === null || _currentTopic$article === void 0 ? void 0 : _currentTopic$article.map(function (article) {
      return toArticleWithPreview(article, currentTopic.name);
    })
  });
  return topic;
};
/**
 * Transforms an IZendeskArticle to an IArticleWithPreview
 */
export var toArticleWithPreview = function toArticleWithPreview(article, section_name) {
  return _objectSpread(_objectSpread({}, article), {}, {
    section_name: section_name,
    preview: getArticlePreview(article)
  });
};